import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { Apollo, gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class UserDetailsService {

  constructor(private readonly apollo: Apollo) {}

  updateUserDetails(firstName: string, lastName: string): Observable<boolean> {
    return this.apollo.mutate<{ updateUserConnected: any }>({
      mutation: gql`
        mutation updateUserConnected($dto: UserUpdateDtoInput!) {
          updateUserConnected(dto: $dto) {
            id
            firstName
            lastName
          }
        }
      `,
      variables: {
        dto: {
          firstName,
          lastName
        }
      }
    }).pipe(
      map(result => !!result.data?.updateUserConnected)
    );
  }

  acceptCgu(): Observable<boolean> {
    return this.apollo.mutate<{ acceptCgu: boolean }>({
      mutation: gql`
        mutation acceptCgu {
          acceptCgu
        }
      `
    }).pipe(
      map(result => !!result.data?.acceptCgu)
    );
  }
}
